import styled from 'styled-components';

const CardType = styled.svg`
`;

const CardNumber = styled.div`
  span {
    margin-right: 10px;
  }
`;

const PaymentMethodMenuContainer = styled.div<any>`
  position: relative;
  align-self: flex-end;
  margin-top: ${p => p.marginTop}px;
  z-index: 1;

  button {
    background-color: transparent !important;
    box-shadow: none !important;
  }
`;

const ExpiredDate = styled.div`
  white-space: nowrap;
  font-size: 18px;
  line-height: 20px;
  margin-right: auto;
`;

const CardStatus = styled.div`
  margin-top: 15px;
  font-size: 12px;
  letter-spacing: 0.18px;
  font-family: 'Light';
  text-transform: uppercase;
  width: 100%;
  display: flex;
  svg {
    width: 20px;
    height: 20px;
    fill: #fff;
    margin-left: auto;
    margin-top: -8px;
    margin-right: 3px;
  }
`;

const PaymentMethodLineContainer = styled.div<any>`
  display: flex;
  color: #fff;
  box-shadow: ${props => props.theme.shadow.l};
  border-radius: 10px;
  background-color: ${p => p.isSubscription ? p.theme.color.turquoise : p.theme.color.disabled};
  cursor: ${p => !p.isSubscription ? 'pointer' : 'default'};
  padding: 10px;
  width: 510px;
  height: 40px;
  box-sizing: border-box;
  align-items: center;
  font-size: 16px;
  line-height: 22px;
  &+& {
    margin-top: 10px;
  }

  ${CardType} {
    min-height: 20px;
    max-height: 20px;
  }

  ${CardNumber} {
    margin-left: 20px;
    min-width: 170px;
  }

  ${ExpiredDate} {
    font-size: 16px;
    margin-right: unset;
  }

  ${CardStatus} {
    margin-top: unset;
    width: 90px;
    margin-left: 41px;
    font-size: 16px;
  }

  ${PaymentMethodMenuContainer} {
    margin-left: auto;
    top: 5px;
  }
`;

const PaymentMethodContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 140px;
  width: 240px;
  padding: 20px;
  margin-right: 20px;
  color: #fff;
  box-shadow: ${props => props.theme.shadow.l};
  border-radius: 15px;
  background-color: ${p => p.isSubscription ? p.theme.color.turquoise : p.theme.color.disabled};
  cursor: ${p => !p.isSubscription ? 'pointer' : 'default'};
  ${CardType} {
    margin: 0 20px;
  }
`;

const PaymentMethodMenu = styled.div`
  position: absolute;
  right: 0;
  bottom: -20px;
  > div {
    padding: 10px 0;
  }
`;

const PaymentMethodRow = styled.div`
  display: flex;
  align-items: center;

  &:last-child {
    margin-top: auto;
  }
`;


export const Styled = {
  PaymentMethodContainer,
  PaymentMethodLineContainer,
  PaymentMethodMenuContainer,
  PaymentMethodMenu,
  PaymentMethodRow,
  CardNumber,
  CardStatus,
  CardType,
  ExpiredDate,
};
